export const TOGGLE_LOADING = 'admin/sessionYear/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'admin/sessionYear/TOGGLE_SUCCESS'
export const GET_SESSIONYEAR = 'admin/sessionYear/GET_SESSIONYEAR'
export const SET_SESSIONYEAR = 'admin/sessionYear/SET_SESSIONYEAR'
export const CREAT_SESSIONYEAR = 'admin/sessionYear/CREAT_SESSIONYEAR'
export const EDIT_SESSIONYEAR = 'admin/sessionYear/EDIT_SESSIONYEAR'
export const DELETE_SESSIONYEAR = 'admin/sessionYear/DELETE_SESSIONYEAR'
export const SET_PERMISSIONS = 'admin/sessionYear/SET_PERMISSIONS'
